
        import { createApi } from '@reduxjs/toolkit/query/react';
        import { createBaseQuery } from 'src/datahandling/redux/api/apiUtils';

        // Initialize an empty API service that we'll inject endpoints into later as needed
        export const customer_settingsApi = createApi({
        reducerPath: 'customer_settingsAutoGeneratedApi',
        baseQuery: createBaseQuery("CUSTOMER_SETTINGS_API"),
        tagTypes: ["UserSettings","CompanySettings"],
        endpoints: () => ({}),
        });

        export type customer_settingsApiType = typeof customer_settingsApi;
        export default customer_settingsApi;
    